import { render, staticRenderFns } from "./MultipleCatalogSelectorTree.vue?vue&type=template&id=36840b53&scoped=true&"
import script from "./MultipleCatalogSelectorTree.vue?vue&type=script&lang=js&"
export * from "./MultipleCatalogSelectorTree.vue?vue&type=script&lang=js&"
import style0 from "./MultipleCatalogSelectorTree.vue?vue&type=style&index=0&id=36840b53&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36840b53",
  null
  
)

export default component.exports